export default {
  dataIterator: {
    rowsPerPageText: 'العناصر لكل صفحة:',
    rowsPerPageAll: 'الكل',
    pageText: '{0}-{1} من {2}',
    noResultsText: 'لا توجد سجلات مطابقة',
    nextPage: 'الصفحة التالية',
    prevPage: 'الصفحة السابقة'
  },
  dataTable: {
    rowsPerPageText: 'الصفوف لكل صفحة:'
  },
  noDataText: 'لا توجد بيانات متاحة',
  carousel: {
    prev: 'الصورة السابقة',
    next: 'البصري التالي'
  }
}
